// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".redirect-app[data-v-0b3bb7a0]{font-size:medium;-webkit-user-select:none;-ms-user-select:none;-moz-user-select:none;user-select:none}.icon[data-v-0b3bb7a0]{font-size:xx-small;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
